module.exports = __webpack_public_path__ + "img/head-mv03.c563c074.jpg";